export enum RoleType {
  ClientManager = 'client_manager',
  SalesRepresentative = 'sales_rep',
  AccountManager = 'account_manager',
  Driver = 'driver',
  Admin = 'admin',
  Manager = 'manager',
  Installer = 'installer',
  SuperAdmin = 'super_admin',
  Support = 'support',
  Reseller = 'reseller',
  ResellerAdmin = 'reseller_admin',
  ResellerAccountManager = 'reseller_account_manager',
  ResellerSalesRepresentative = 'reseller_sales_manager',
}
